import React from 'react'
import styled from 'styled-components'

import { Box } from 'pcln-design-system'

import { useAccordionState } from './AccordionProvider'

const CollapsibleSection = styled(Box)`
  max-height: ${({ open }) => (open ? '100vh' : 0)};
  height: 100%;
  overflow: hidden;

  ${({ shouldAnimate }) => (shouldAnimate ? 'transition: max-height 0.4s;' : null)}
`

export interface IAccordionContent {
  children?: React.ReactNode
  className?: string
  p?: string | number
}

const AccordionContent = ({ children, className, ...props }: IAccordionContent) => {
  const { open, shouldAnimate, shouldMapOpenPropToContent } = useAccordionState()

  return (
    <CollapsibleSection
      open={open}
      shouldAnimate={shouldAnimate}
      className={className}
      data-testid='CollapsibleSection'
      aria-hidden={!open}
    >
      <Box {...props}>
        {shouldMapOpenPropToContent
          ? React.Children.map(children, (child) =>
              React.cloneElement(child as React.ReactElement, {
                isAccordionOpen: open,
              })
            )
          : children}
      </Box>
    </CollapsibleSection>
  )
}

export default AccordionContent
